import { Breadcrumbs, CircularProgress, Grid2 } from "@mui/material";
import React, { useEffect, useState } from "react";
//styles
import styles from "./ProfileStyle.module.scss";
import NewChangeDetails from "./Components/ChangeDetails/NewChangeDetails";
import NewChangePassword from "./Components/ChangePassword/NewChangePassword";
import { useNavigate } from "react-router-dom";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import LocationDetails from "./Components/LocationDetails/LocationDetails";
import AccountSettings from "./Components/AccountSettings/AccountSettings";
// import NewEmailNotifications from "../../../../../GlobalComponents/EmailNotifications/NewEmailNotifications";
import { useSelector } from "react-redux";
import CustomButton from "../../../../../GlobalComponents/CustomButton/CustomButton";
import { Actions } from "../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../Utils/storeUtils";
import {
  formatPhoneNumber,
  PhoneNumberformat,
  verifyEmail,
  verifyLength,
  verifyPassword,
  verifyPhoneNumber,
} from "../../../../../Utils/utils";
import FormPopup from "../../../../../GlobalComponents/FormPopup/FormPopup";
import { updatePassword } from "aws-amplify/auth";

// const notificationSettings = [
//   {
//     title: "Wordpress overage",
//     subTitle:
//       "If you reach your plan's limits, we'll keep your WordPress sites running but charge you an overage fee. We'll send you a notification at 80% and 100% usage.",
//   },
//   {
//     title: "Product updates",
//     subTitle:
//       "Receive product news about feature releases, data centers, add-ons, and more useful information to get the most out of your hosting. Delivered monthly to your email.",
//   },
//   {
//     title: "Invoice in email",
//     subTitle: "This will send you the invoice emails of all your purchases.",
//   },
//   {
//     title: "Wordpress site monitoring",
//     subTitle:
//       "Receive all the notifications about your site by enabling. This includes downtime alerts, DNS and SSL errors, domain expiry and more.",
//   },
// ];

function Profile(props) {
  //hooks
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [currentpassword, setCurrentPassword] = useState("");
  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");

  const [values, setValues] = useState({
    email: "",
    emailState: "error",
    name: "",
    nameState: "error",
    avatarState: "error",
    phoneNumber: "",
    phoneNumberState: "error",
    country: "",
    countryState: "",
    zipCode: "",
    zipCodeState: "",
  });
  const [inputErrorVar, setInputErrorVar] = useState({
    email: false,
    password: false,
    confirmPassword: false,
    phoneNumber: false,
    name: false,
  });
  const [passFormData, setPassFormData] = useState({
    currentpassword: "",
    currentpasswordError: false,
    newpassword: "",
    newpasswordError: false,
    newpasswordErrorMessage:
      "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
    confirmpassword: "",
    confirmpasswordError: false,
    confirmpasswordErrorMessage: "",
  });

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupButtonTitle: "",
    popupButtonFunction: () => {},
  });

  // useSelector
  let loggedInUserInfoDB = useSelector((state) => state.users.userDetails);

  const ActivatePopup = (type) => {
    if (type === "loading") {
      setPopup({
        popupState: true,
        popupTitle: "Updating...",
        popupSubtitle: "Please wait while we save your changes.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Update Failed",
        popupSubtitle: "Something went wrong. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success_name") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Name Updated",
        popupSubtitle: "Your name has been changed successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success_contact") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Contact Updated",
        popupSubtitle: "Your contact number has been changed successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success_both") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Details Updated",
        popupSubtitle:
          "Your name and contact number have been changed successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success_password") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Password Changed",
        popupSubtitle: "Your password has been updated successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "success_details_and_password") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Profile Updated",
        popupSubtitle:
          "Your details and password have been updated successfully.",
        popupButton: true,
        popupCancel: false,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          ActivatePopup("none");
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  //useEffects
  let formattedPhoneNumber = loggedInUserInfoDB?.phoneNumber;
  useEffect(() => {
    if (loggedInUserInfoDB) {
      if (
        loggedInUserInfoDB.country === "USA" &&
        formattedPhoneNumber.startsWith("+1")
      ) {
        formattedPhoneNumber = formattedPhoneNumber.substring(2); // Remove "+1" for USA
      } else if (
        loggedInUserInfoDB.country === "India" &&
        formattedPhoneNumber.startsWith("+91")
      ) {
        formattedPhoneNumber = formattedPhoneNumber.substring(3); // Remove "+91" for India
      }

      setValues({
        name: loggedInUserInfoDB.userName,
        email: loggedInUserInfoDB.emailId,
        phoneNumber: formattedPhoneNumber,
        country: loggedInUserInfoDB.country,
      });
    }
  }, [loggedInUserInfoDB]);

  useEffect(() => {
    if (loggedInUserInfoDB) {
      const formattedPhoneNumber = formatPhoneNumber(
        loggedInUserInfoDB.phoneNumber,
        loggedInUserInfoDB.country
      );

      setValues({
        name: loggedInUserInfoDB.userName,
        email: loggedInUserInfoDB.emailId,
        phoneNumber: formattedPhoneNumber,
        country: loggedInUserInfoDB.country,
      });
    }
  }, [loggedInUserInfoDB]);

  useEffect(() => {
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({ type: Actions.API_CHECK_USER_HAS_PLAN });
  }, []);

  //member functions
  const changedValue = () => {
    if (loggedInUserInfoDB) {
      const formattedPhoneNumber = formatPhoneNumber(
        loggedInUserInfoDB.phoneNumber,
        loggedInUserInfoDB.country
      );

      return (
        values.name !== loggedInUserInfoDB.userName ||
        values.phoneNumber !== formattedPhoneNumber ||
        values.country !== loggedInUserInfoDB.country
      );
    }
    return false;
  };

  const handleChange = (prop, type, value, length, metaData) => {
    let status = "";
    let formattedValue = value;
    switch (type) {
      case "email":
        status = verifyEmail(value) ? "success" : "error";
        break;
      case "phoneNumber":
        formattedValue = value.replace(/\D/g, "");
        if (formattedValue.length > 10) {
          formattedValue = formattedValue.substring(0, 10);
        }
        formattedValue = PhoneNumberformat(formattedValue, values.country);
        status = verifyPhoneNumber(formattedValue, values.country)
          ? "success"
          : "error";
        break;
      case "country":
        formattedValue = value.value;
        setValues((prevValues) => ({
          ...prevValues,
          country: formattedValue,
          phoneNumber: "",
          phoneNumberState: "error",
        }));
        break;
      case "length":
        status = verifyLength(value, length) ? "success" : "error";
        break;
      default:
        break;
    }
    setValues((prevValues) => ({
      ...prevValues,
      [prop + "State"]: status,
      [prop]: formattedValue,
    }));
    setInputErrorVar((prevInputErrorVar) => ({
      ...prevInputErrorVar,
      [prop]: status === "error",
    }));
  };

  const handleSubmitChangeDetails = async () => {
    if (values.nameState === "error" || values.phoneNumberState === "error") {
      setInputErrorVar({
        email: values.emailState === "error",
        phoneNumber: values.phoneNumberState === "error",
        name: values.nameState === "error",
      });
      setLoading(false);
      return;
    }
    if (loggedInUserInfoDB && changedValue()) {
      setLoading(true);
      // Filtering phoneNumber
      let phoneNumber = values.phoneNumber
        .replace("(", "")
        .replace(")", "")
        .replace("-", "")
        .replace(" ", "");
      const updatedUserDetails = {
        userName: values.name,
        phoneNumber:
          (values.country === "USA" && "+1" + phoneNumber) ||
          (values.country === "India" && "+91" + phoneNumber),
        country: values.country,
      };
      getStore().dispatch({
        type: Actions.API_UPDATE_USER_DETAILS,
        userDetails: updatedUserDetails,
        meta: {
          onSuccess: () => {
            getStore().dispatch({ type: Actions.API_USER_DETAILS });
            setValues((prevValues) => ({
              ...prevValues,
              nameState: "success",
            }));
            setInputErrorVar((prevInputErrorVar) => ({
              ...prevInputErrorVar,
              name: false,
            }));
            setLoading(false);
            const hasNameChanged =
              updatedUserDetails.userName !== loggedInUserInfoDB.userName;
            const hasPhoneNumberChanged =
              updatedUserDetails.phoneNumber !== loggedInUserInfoDB.phoneNumber;
            if (hasNameChanged && hasPhoneNumberChanged) {
              ActivatePopup("success_both");
            } else if (hasNameChanged) {
              ActivatePopup("success_name");
            } else if (hasPhoneNumberChanged) {
              ActivatePopup("success_contact");
            }
          },
          onError: () => {
            setLoading(false);
            ActivatePopup("error");
          },
        },
      });
    }
  };

  const passFormUpdate = (value, type) => {
    if (type === "Current Password") {
      setCurrentPassword(value);
      setNewPassword("");
      setConfirmPassword("");
      setPassFormData((prevState) => ({
        ...prevState,
        newpasswordError: null,
        newpasswordErrorMessage: "",
      }));
      return;
    } else if (type === "New Password") {
      setNewPassword(value);
    } else if (type === "Confirm New Password") {
      setConfirmPassword(value);
    }
    formValidator(value, type);
  };

  // Validations
  const formValidator = (value, type) => {
    if (type === "Current Password") {
      if (!verifyPassword(value)) {
        setPassFormData({ ...passFormData, currentpasswordError: true });
      } else {
        setPassFormData({ ...passFormData, currentpasswordError: false });
      }
    } else if (type === "New Password") {
      if (
        !verifyPassword(value) ||
        value === currentpassword ||
        !(confirmpassword === "" || value === confirmpassword)
      ) {
        setPassFormData({
          ...passFormData,
          newpasswordError:
            value === currentpassword ? true : !verifyPassword(value),
          newpasswordErrorMessage:
            value === currentpassword
              ? "New Password cannot be the same as Current Password"
              : passFormData.newpasswordErrorMessage,
        });
      } else {
        setPassFormData({
          ...passFormData,
          newpasswordError: false,
          confirmpasswordError: false,
        });
      }
    } else if (type === "Confirm New Password") {
      if (!verifyPassword(value)) {
        setPassFormData((prev) => ({
          ...prev,
          confirmpasswordError: true,
          confirmpasswordErrorMessage: "",
        }));
      } else {
        if (value === newpassword) {
          setPassFormData((prev) => ({
            ...prev,
            confirmpasswordError: false,
            confirmpasswordErrorMessage: "",
          }));
        } else {
          setPassFormData((prev) => ({
            ...prev,
            confirmpasswordError: true,
            confirmpasswordErrorMessage: "Passwords do not match.",
          }));
        }
      }
    }
  };

  // Handle Submit
  const handleSubmitChangePassword = async () => {
    // Check if the new password matches the current password
    if (currentpassword === newpassword) {
      setPassFormData((prevState) => ({
        ...prevState,
        newpasswordError: true,
        newpasswordErrorMessage:
          "New Password cannot be the same as Current Password",
      }));
      return;
    }
    // Check if the confirm password matches the new password
    if (newpassword !== confirmpassword) {
      setPassFormData((prevState) => ({
        ...prevState,
        confirmpasswordError: true,
        confirmpasswordErrorMessage:
          "Confirm Password must match the New Password",
      }));
      return;
    }
    if (
      currentpassword !== "" &&
      newpassword !== "" &&
      confirmpassword !== "" &&
      !passFormData.currentpasswordError &&
      !passFormData.newpasswordError &&
      !passFormData.confirmpasswordError
    ) {
      setLoading(true);
      try {
        await updatePassword({
          oldPassword: currentpassword,
          newPassword: newpassword,
        });
        ActivatePopup("success_password");
      } catch (err) {
        ActivatePopup("error");
      } finally {
        setLoading(false);
      }
    }
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");

    setPassFormData({
      currentpassword: "",
      currentpasswordError: false,
      newpassword: "",
      newpasswordError: false,
      newpasswordErrorMessage:
        "Requires at least 8 characters with one capital letter, one numeric character, and one special character",
      confirmpassword: "",
      confirmpasswordError: false,
      confirmpasswordErrorMessage: "",
    });
  };

  const hasPlanData = useSelector((state) => state?.users?.hasPlan);

  const handleBackClick = () => {
    if (hasPlanData) {
      navigate("/account/organizations-overview");
    } else navigate("/account/buy-plan");
  };

  // --- Combined Save Handler ---
  const handleSave = async () => {
    setLoading(true);
    const detailsChanged = changedValue();
    const passwordRequested = currentpassword || newpassword || confirmpassword;
    try {
      if (detailsChanged && passwordRequested) {
        await Promise.all([
          handleSubmitChangeDetails(),
          handleSubmitChangePassword(),
        ]);
        ActivatePopup("success_details_and_password");
      } else if (detailsChanged) {
        await handleSubmitChangeDetails();
      } else if (passwordRequested) {
        await handleSubmitChangePassword();
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid2 className={styles.Container}>
        <Grid2 className={styles.FlexBox}>
          <Breadcrumbs
            aria-label="breadcrumb"
            separator={<div className={styles.separatorColor}>/</div>}
          >
            <Grid2 className={styles.options} onClick={handleBackClick}>
              <CorporateFareIcon />
              <Grid2>Organizations-overview</Grid2>
            </Grid2>
            <Grid2 className={styles.activeOption}>Profile & Settings</Grid2>
          </Breadcrumbs>
          <Grid2 className={styles.header}>Profile & Settings</Grid2>
          <CustomButton
            className={styles.CustomButton}
            onClick={handleSave}
            disabled={
              loading ||
              !(
                changedValue() ||
                (currentpassword &&
                  newpassword &&
                  confirmpassword &&
                  newpassword === confirmpassword &&
                  !passFormData.currentpasswordError &&
                  !passFormData.newpasswordError &&
                  !passFormData.confirmpasswordError)
              )
            }
          >
            {loading ? (
              <CircularProgress size={20} color="inherit" />
            ) : (
              "Save Changes"
            )}
          </CustomButton>
        </Grid2>
        <Grid2 className={styles.cards}>
          <Grid2 className={styles.backGround}>
            <Grid2 className={styles.ChangeDetails}>
              <NewChangeDetails
                values={values}
                handleChange={handleChange}
                inputErrorVar={inputErrorVar}
              />
              <LocationDetails loggedInUserInfoDB={loggedInUserInfoDB} />
            </Grid2>
            <Grid2 className={styles.ChangePassword}>
              <NewChangePassword
                passFormUpdate={passFormUpdate}
                passFormData={passFormData}
                currentpassword={currentpassword}
                newpassword={newpassword}
                confirmpassword={confirmpassword}
              />
              <AccountSettings />
            </Grid2>
          </Grid2>
          <Grid2>
            {/* <NewEmailNotifications notifications={notificationSettings} /> */}
          </Grid2>
        </Grid2>
      </Grid2>
      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
        />
      </section>
    </>
  );
}

export default Profile;
